import React from 'react';

import LimitItems from '../../../components/LimitItems';
import MembersToolbar from '../OrganizationMemberList/MembersToolbar';
import useColumnVisibility from '../../../hooks/useColumnVisibility';
import { buildColumnOptions } from '../../../utils/tableColumns';
import useGetCheckinMembers from '../api/useGetCheckinMembers';
import useListQueryParams from '../OrganizationMemberList/useListQueryParams';
import CheckinMembersList from './CheckinMemberList';
import { CHECKIN_COLUMNS, CHECKIN_COLUMNS_STORAGE_KEY, CheckinColumnId } from './columns';

const CheckinMembersPage: React.FC = () => {
    const { query } = useListQueryParams();
    const { limit, offset } = query;

    const { data, isFetching: isLoading, isError } = useGetCheckinMembers(query);

    const { isVisible, toggle } = useColumnVisibility(CHECKIN_COLUMNS_STORAGE_KEY, CHECKIN_COLUMNS);

    const columnControl = {
        options: buildColumnOptions(CHECKIN_COLUMNS, isVisible),
        onToggle: (id: string) => toggle(id as CheckinColumnId)
    };

    return (
        <>
            <MembersToolbar>
                <LimitItems
                    limit={limit ? +limit : 10}
                    offset={offset ? +offset : 0}
                    total_count={data?.total_count}
                    isLoading={isLoading}
                    columnControl={columnControl}
                />
            </MembersToolbar>

            <CheckinMembersList
                isError={isError}
                isLoading={isLoading}
                data={data}
                listQuery={query}
                isColumnVisible={isVisible}
            />
        </>
    );
};

export default CheckinMembersPage;
